import { Button, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { PageNotFoundIllustration } from '../assets/illustrations';
import { MotionContainer, varBounce } from '../components/animate';

export default function Page404() {
  return (
    <>
      <Helmet>
        <title> Página não encontrada</title>
      </Helmet>

      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Página não encontrada!
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Lamentamos, mas não conseguimos encontrar a página que você procura. Talvez você tenha
            digitado incorretamente o endereço? Certifique-se de verificar sua ortografia.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <PageNotFoundIllustration
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>

        <Button component={RouterLink} to="/" size="large" variant="contained">
          Voltar a Página Incial
        </Button>
      </MotionContainer>
    </>
  );
}
